import { MapApiResponse } from '../../api-models';
import { HTTPMethod, MapType } from '../../types/enums';
import { AdapterInterface, MapClient } from '../../types/global';

import BaseAdapter from './baseAdapter';

export default class PostMapClient extends BaseAdapter<MapApiResponse> implements AdapterInterface {
  rawResponse: MapApiResponse;

  private static mapViewToMapType(mapView: MapApiResponse['map_view']): MapType {
    if (mapView === 'Ward map') {
      return MapType.WardMap;
    }
    return MapType.HouseholdMap;
  }

  async adaptResponse(): Promise<MapClient> {
    await this.fetchApiResponse('/api/map-client', HTTPMethod.Post);
    return {
      key: this.rawResponse.key,
      latitude: this.rawResponse.lat,
      longitude: this.rawResponse.lng,
      mapType: PostMapClient.mapViewToMapType(this.rawResponse.map_view),
    };
  }
}
